import Button from "components/atoms/Button";
import React from "react";
import { monthConverter } from "utils/common";
import { formatParasite } from "utils/parasite";
import { useHistory } from "react-router-dom";

const TableComponent = ({
  reportsData,
  tableRef,
  reportInfo,
  currentLevel,
}) => {
  const history = useHistory();

  let levelName = "";

  if (currentLevel === "national") {
    levelName = "Nasional";
  } else if (currentLevel === "province") {
    levelName = "Provinsi";
  } else if (currentLevel === "district") {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Lab";
  }

  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  let data = reportInfo?.lab;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  const onViewDetailData = (id) => {
    history.push(`/detail-register-malaria-1-from-lpkl34/${id}`);
  };

  return (
    <div
      className="table-responsive"
      style={{ backgroundColor: "#fff" }}
      ref={tableRef}
    >
      <table>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingBottom: 0 }}>
            <h3>
              SISMAL v3, Rekap Data Individu {formatParasite("Knowlesi")} - Lab
            </h3>
          </th>
        </tr>
      </table>
      <table>
        <tr style={{ border: "none" }}>
          <th
            width="200"
            style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
          >
            Periode Laporan
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {periodeName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Tahun
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {reportInfo?.periode?.year}
          </th>
        </tr>
        {periodeName === "Bulanan" && (
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Bulan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {monthConverter(reportInfo?.periode?.month_start)} - {monthConverter(reportInfo?.periode?.month_end)}
            </th>
          </tr>
        )}
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Level
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {levelName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Provinsi
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.province
              ? "Semua Provinsi"
              : reportInfo?.province?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Kab/Kota
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.district
              ? "Semua Kab/Kota"
              : reportInfo?.district?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0 }}>Lab</th>
          <th style={{ border: "none", paddingTop: 0 }}>
            : {!reportInfo?.lab ? "Semua Lab" : result}
          </th>
        </tr>
      </table>
      <table>
        <thead>
          <tr>
            <th>Nama Pasien</th>
            <th>Kode Slide</th>
            <th>Alamat Domisili</th>
            <th>Pekerjaan</th>
            <th>Jenis Parasit</th>
            <th>Tanggal pengiriman sampel</th>
            <th>Kondisi Sampel Sediaan Apusan Darah (SAD) Memenuhi Syarat</th>
            <th>Kondisi Sampel Dried Blood Spot (DBS) Memenuhi Syarat</th>
            <th>Kondisi Sampel Whole Blood EDTA (WB) Memenuhi Syarat</th>
            <th>Tanggal Keluar Hasil</th>
            <th>Hasil Pemeriksaan PCR</th>
            {/* <th>Aksi</th> */}
          </tr>
        </thead>
        <tbody>
          {reportsData?.length > 0 ? (
            reportsData?.map((item, index) => (
              <tr key={index}>
                <td>{item?.patient_name}</td>
                <td>{item?.slide_code}</td>
                <td>{item?.address}</td>
                <td>{item?.job}</td>
                <td>{formatParasite(item?.parasyte)}</td>
                <td>
                  {item?.sample_sad_send_date ||
                    item?.sample_dbs_send_date ||
                    item?.sample_wb_send_date ||
                    "-"}
                </td>
                <td>{item?.sample_sad_condition}</td>
                <td>{item?.sample_dbs_condition}</td>
                <td>{item?.sample_wb_condition}</td>
                <td>{item?.pcr_finish_checking_date}</td>
                <td>{formatParasite(item?.pcr_checking_result)}</td>
               {/*  <td>
                  <Button
                    variant={"primary"}
                    size={"normal"}
                    onClick={() => onViewDetailData(item.regmal_id)}
                  >
                    Lihat Regmal 1
                  </Button>
                </td> */}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={11}>Tidak Ada Data</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableComponent;
